// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin: 40px 20px;
}

:host-context(html.mc-android-edge-to-edge.md.mc-android-nav-buttons) {
  padding-bottom: 40px;
}

/* min-width 640px, medium screens */
ion-title {
  font-family: Inter;
  color: var(--ion-color-black);
  margin-left: 26px;
  font-weight: 600;
  letter-spacing: -0.32px;
  font-size: 18px;
  padding: 0;
  padding-bottom: 20px;
}

ion-row {
  row-gap: 20px;
}
ion-row ion-col {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
ion-row ion-col div {
  text-align: center;
}
ion-row ion-col div ion-label {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: -0.18px;
  color: var(--mc-color-dark-grey);
  margin: 0 auto;
  font-family: Roboto;
}
ion-row ion-col div ion-avatar {
  width: 60px;
  aspect-ratio: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-radius: 5px;
  margin: 0 auto;
}
ion-row ion-col div ion-avatar ion-icon {
  font-size: 40px;
}
ion-row ion-col div ion-avatar.active {
  background: var(--mc-color-light-grey);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/main-menu/main-menu.component.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;AADD;;AAIA;EACC,oBAAA;AADD;;AAOA,oCAAA;AAGA;EACC,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;AAND;;AAQA;EACC,aAAA;AALD;AAMC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAKE;EACC,kBAAA;AAHH;AAIG;EACC,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;AAFJ;AAIG;EACC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAFJ;AAGI;EACC,eAAA;AADL;AAGI;EACC,sCAAA;AADL","sourcesContent":["\r\n\r\n:host {\r\n\tmargin: 40px 20px;\r\n}\r\n\r\n:host-context(html.mc-android-edge-to-edge.md.mc-android-nav-buttons) {\r\n\tpadding-bottom: 40px;\r\n}\r\n\r\n@media only screen {\r\n}\r\n\r\n/* min-width 640px, medium screens */\r\n@media only screen and (min-width: 640px) {\r\n}\r\nion-title {\r\n\tfont-family: Inter;\r\n\tcolor: var(--ion-color-black);\r\n\tmargin-left: 26px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: -.32px;\r\n\tfont-size: 18px;\r\n\tpadding: 0;\r\n\tpadding-bottom: 20px;\r\n}\r\nion-row {\r\n\trow-gap: 20px;\r\n\tion-col {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tflex-direction: row;\r\n\t\tdiv {\r\n\t\t\ttext-align: center;\r\n\t\t\tion-label {\r\n\t\t\t\tfont-size: 11px;\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tletter-spacing: -.18px;\r\n\t\t\t\tcolor: var(--mc-color-dark-grey);\r\n\t\t\t\tmargin: 0 auto;\r\n\t\t\t\tfont-family: Roboto;\r\n\t\t\t}\r\n\t\t\tion-avatar {\r\n\t\t\t\twidth: 60px;\r\n\t\t\t\taspect-ratio: 1;\r\n\t\t\t\ttext-align: center;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\tflex-direction: row;\r\n\t\t\t\tborder-radius: 5px;\r\n\t\t\t\tmargin: 0 auto;\r\n\t\t\t\tion-icon {\r\n\t\t\t\t\tfont-size: 40px;\r\n\t\t\t\t}\r\n\t\t\t\t&.active {\r\n\t\t\t\t\tbackground: var(--mc-color-light-grey);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
